import { render, staticRenderFns } from "./Jela.vue?vue&type=template&id=365ebc41&scoped=true&"
import script from "./Jela.vue?vue&type=script&lang=js&"
export * from "./Jela.vue?vue&type=script&lang=js&"
import style0 from "./Jela.vue?vue&type=style&index=0&id=365ebc41&prod&lang=css&"
import style1 from "./Jela.vue?vue&type=style&index=1&id=365ebc41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ebc41",
  null
  
)

export default component.exports